import { userRole } from '@hm_app/users/users-auth-guard';
import { BaseHmComponent } from './../base-hm/base-hm.component';
import { RuoliUtente } from './../../@core/models/utente';
import { Component, OnInit } from '@angular/core';
import { NbRoleProvider } from '@nebular/security';
import { firstRole, adminOrSuperAdminRole, superAdminRole, adminOrOperatorRole, operatorRole, monitorRole } from '@hm_app/_helpers/roles';

import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { NbToastrService } from '@nebular/theme';
import { AuthUser } from '@hm_app/@core/models/auth_user';

@Component({
    selector: 'ngx-base-authenticated',
    templateUrl: './base-authenticated.component.html',
    styleUrls: ['./base-authenticated.component.scss'],
})
export class BaseAuthenticatedComponent extends BaseHmComponent implements OnInit {

    roles: RuoliUtente[];

    user: AuthUser;

    get role(): RuoliUtente {
        if (!this.roles || this.roles.length == 0) {
            return null;
        }
        return firstRole(this.roles);

    }

    get isAdmin(): boolean {
        return adminOrSuperAdminRole(this.roles);
    }

    get isSuperAdmin(): boolean {
        return superAdminRole(this.roles);
    }

    get isMonitor(): boolean {
        return monitorRole(this.roles);
    }

    get isAdminOrOperator(): boolean {
        return adminOrOperatorRole(this.roles);
    }


    get isOperator(): boolean {
        return operatorRole(this.roles);
    }


    get isUser(): boolean {
        return userRole(this.roles);
    }

    constructor(
        protected hmService: HappyMammaService,
        protected toastrService: NbToastrService,
        protected roleProvider: NbRoleProvider) {
        super(hmService, toastrService);
        this.roleProvider.getRole().subscribe(roles => this.roles = roles as RuoliUtente[]);

        this.hmService.auth_user$.subscribe(utente => {
            this.setUser(utente);
        });
        this.setUser(this.hmService.auth_user);

    }

    setUser(user: AuthUser) {
        this.user = user;
    }

    async ngOnInit() {
    }

}
